var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "page-header",
        {
          attrs: {
            title: _vm.$t("pages.admin.video.title"),
            "icon-class": "mdi mdi-frequently-asked-questions"
          }
        },
        [
          _c(
            "div",
            { staticClass: "text-right" },
            [
              _c(
                "router-link",
                {
                  staticClass: "text-primary font-weight-bold",
                  attrs: { tag: "a", to: { name: "admin.video.upload" } }
                },
                [
                  _c("i", { staticClass: "mdi mdi-plus" }),
                  _vm._v(
                    " " + _vm._s(_vm.$t("actions.upload")) + "\n            "
                  )
                ]
              )
            ],
            1
          )
        ]
      ),
      _vm._v(" "),
      _c("div", { staticClass: "row" }, [
        _c(
          "div",
          { staticClass: "col-12 grid-margin stretch-card" },
          [
            _c("video-filter", {
              ref: "filter",
              attrs: {
                videos: _vm.videos,
                "pagination-data": _vm.paginationData
              },
              on: {
                "update:videos": function($event) {
                  _vm.videos = $event
                },
                "update:paginationData": function($event) {
                  _vm.paginationData = $event
                },
                "update:pagination-data": function($event) {
                  _vm.paginationData = $event
                }
              }
            })
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "row" }, [
        _c("div", { staticClass: "col-12 grid-margin stretch-card" }, [
          _c("div", { staticClass: "card shadow-sm" }, [
            _c(
              "div",
              { staticClass: "card-body" },
              [
                _c("static-loading-indicator-icon", {
                  attrs: { loading: _vm.$store.getters.shouldLoadLocal }
                }),
                _vm._v(" "),
                !_vm.$store.getters.shouldLoadLocal
                  ? _c("div", [
                      _c("h5", { staticClass: "card-title mb-3" }, [
                        _vm._v(
                          "\n                            " +
                            _vm._s(_vm.$t("pages.admin.video.index.title")) +
                            "\n                        "
                        )
                      ]),
                      _vm._v(" "),
                      _vm.videos.length
                        ? _c(
                            "div",
                            { staticClass: "table-responsive" },
                            [
                              _c(
                                "table",
                                {
                                  staticClass:
                                    "table table-borderless table-striped"
                                },
                                [
                                  _c("thead", [
                                    _c("tr", [
                                      _c("td", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t(
                                              "pages.admin.video.model.thumbnail"
                                            )
                                          )
                                        )
                                      ]),
                                      _vm._v(" "),
                                      _c("td", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t(
                                              "pages.admin.video.model.title"
                                            )
                                          )
                                        )
                                      ]),
                                      _vm._v(" "),
                                      _c("td", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t(
                                              "pages.admin.video.model.status"
                                            )
                                          )
                                        )
                                      ]),
                                      _vm._v(" "),
                                      _c("td", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t(
                                              "pages.admin.video.model.duration"
                                            )
                                          )
                                        )
                                      ]),
                                      _vm._v(" "),
                                      _c("td", [
                                        _vm._v(
                                          _vm._s(_vm.$t("actions.actions"))
                                        )
                                      ])
                                    ])
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "tbody",
                                    _vm._l(_vm.videos, function(video) {
                                      return _c("tr", [
                                        _c("td", { attrs: { width: "150" } }, [
                                          _c("img", {
                                            staticClass: "img-fluid",
                                            staticStyle: {
                                              height: "72px",
                                              width: "128px",
                                              "border-radius": "8px  !important"
                                            },
                                            attrs: {
                                              src: _vm.hasKissVideo(video)
                                                ? video.kiss_video
                                                    .actual_thumbnail_url
                                                : "https://placehold.it/150",
                                              alt: video.title[_vm.$i18n.locale]
                                            }
                                          })
                                        ]),
                                        _vm._v(" "),
                                        _c("td", [
                                          _vm._v(
                                            _vm._s(
                                              video.title[_vm.$i18n.locale]
                                            )
                                          )
                                        ]),
                                        _vm._v(" "),
                                        _c("td", [
                                          _vm.fullyTranscoded(video)
                                            ? _c(
                                                "span",
                                                {
                                                  staticClass:
                                                    "badge badge-success"
                                                },
                                                [_vm._v("Public")]
                                              )
                                            : _c(
                                                "span",
                                                {
                                                  staticClass:
                                                    "badge badge-warning"
                                                },
                                                [
                                                  _vm._v(
                                                    "Currently transcoding"
                                                  )
                                                ]
                                              )
                                        ]),
                                        _vm._v(" "),
                                        _c("td", [
                                          _c(
                                            "span",
                                            { staticClass: "badge badge-dark" },
                                            [
                                              _vm._v(
                                                "\n                                                " +
                                                  _vm._s(video.duration / 60) +
                                                  " Minutes\n                                            "
                                              )
                                            ]
                                          )
                                        ]),
                                        _vm._v(" "),
                                        _c("td", [
                                          _c(
                                            "button",
                                            {
                                              staticClass:
                                                "btn btn-outline-warning btn-sm",
                                              on: {
                                                click: function($event) {
                                                  return _vm.$router.push({
                                                    name: "admin.video.edit",
                                                    params: { video: video.id }
                                                  })
                                                }
                                              }
                                            },
                                            [
                                              _c("i", {
                                                staticClass: "mdi mdi-pencil"
                                              })
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "button",
                                            {
                                              staticClass:
                                                "btn btn-outline-dark btn-sm",
                                              on: {
                                                click: function($event) {
                                                  return _vm.$router.push({
                                                    name: "admin.video.stats",
                                                    params: { video: video.id }
                                                  })
                                                }
                                              }
                                            },
                                            [
                                              _c("i", {
                                                staticClass:
                                                  "mdi mdi-chart-timeline-variant"
                                              })
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "button",
                                            {
                                              staticClass:
                                                "btn btn-outline-danger btn-sm float-right",
                                              on: {
                                                click: function($event) {
                                                  _vm.selectedVideo = video
                                                }
                                              }
                                            },
                                            [
                                              _c("i", {
                                                staticClass: "mdi mdi-trash-can"
                                              })
                                            ]
                                          )
                                        ])
                                      ])
                                    }),
                                    0
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "mt-3" },
                                [
                                  _c("pagination", {
                                    attrs: { data: _vm.paginationData },
                                    on: {
                                      "pagination-change-page": _vm.loadPage
                                    }
                                  })
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c("video-delete-modal", {
                                attrs: { selected: _vm.selectedVideo },
                                on: {
                                  "video-deleted": _vm.onVideoDeleted,
                                  "modal-close": function($event) {
                                    _vm.selectedVideo = null
                                  }
                                }
                              })
                            ],
                            1
                          )
                        : _c(
                            "div",
                            {
                              staticClass: "alert alert-secondary border-dark"
                            },
                            [
                              _vm._v(
                                "\n                            " +
                                  _vm._s(
                                    _vm.$t("pages.admin.video.index.none_found")
                                  ) +
                                  "\n                        "
                              )
                            ]
                          )
                    ])
                  : _vm._e()
              ],
              1
            )
          ])
        ])
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }